import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseDataService } from "../base-data-service";
import { AppConfigService } from "@tmhcc-ng-lib/global-services";
import { DateService,DateFormats } from "@tmhcc-ng-lib/framwork/services";
import { CommonContentService } from "@tmhcc-ng-lib/content-service";
import { map, catchError } from "rxjs/operators";
import {      
  KnrPolicySearchRequest
} from "../def/knr-quote-policy-search";
import {      
  KnrPolicySearchResponse,KnrPolicySearchResult,
} from "../../models/classes/knr-policy-gird.model";
import {      
  QuoteResponseData,quoteDetail,UpdateQuoteRequest
} from "../../models/classes/knr-quote-details.model";
import {RatingRequest} from "libs/data-service/def/knr-rating";
import {      
  RatingResponse,FinalPremiums,Premiums,
  WWExposure,LimitPremiums
} from "../../models/classes/knr-rating.model";
import {AccountSetupResponse} from "../../models/classes/knr-account-data.model";
import {RatingDataResponse} from "../../models/classes/knr-rating-data.model";
import { QuoteInfoCoveragesResponse } from "../../models/classes/knr-quote-info-coverages.model";
import { SubjectivitiesDataResponse,KnRSubjectivityGrid,KnRSubjectivityGridRow } from "../../models/classes/knr-subjectivities-data.model";
import { of } from 'rxjs';
import { QuoteInfoCoveragesRequest } from "libs/data-service/def/knr-quote-info-coverages";
import { RenewalInfoDataResponse } from "../../models/classes/knr-renewalinfo-data.model"
import { RenewalInfoResponse } from "../../models/classes/knr-renewalinfo.model"
import {KnRSaveSubjectiviyRequest,KnRSubjectivityRequest} from "libs/data-service/def/knrsubjectivity";
import { EndorsementsDataResponse,KnREndorsementsGrid,KnREndorsementsGridRow } from "../../models/classes/knr-endorsements-data.model";
import { KnRSaveEndorsementsRequest } from "libs/data-service/def/knrendorsements";
import { SaveCountryDetailsRequest } from "libs/data-service/def/knrcountrydetails";
import { EndorsementsVariablesRequest } from "libs/data-service/def/knr-endorsements-var";
import { CountryDetailsDataResponse,CountryDetailsList,CountryDetailsRow } from "../../models/classes/knr-countrydetails-data.model";
import {EndorsementsVarDataResponse,endorsementsVariablesDetails} from "../../models/classes/knr-endorsements-var-data.model";
import {RenewalInfoRequest} from "libs/data-service/def/knr-renewal-info";
@Injectable()
export class KnrPolicyQuoteService extends BaseDataService {
  accountSetupCachedData:AccountSetupResponse;
  ratingCachedData: RatingDataResponse;
  quoteInfoCoveragesCacheData: QuoteInfoCoveragesResponse;
  subjectivitiesDataResponseCache: SubjectivitiesDataResponse;
  endorsementsDataResponseCache: EndorsementsDataResponse;
  quoteDetailCache: quoteDetail;
  endorsementsVariableDataResponseCache: EndorsementsVarDataResponse;
  token: any;

  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    private dateService: DateService,
    private commonContentService: CommonContentService
  ) {
    super(http, configService);

    this.token = JSON.parse(localStorage.getItem('okta-token-storage'));
  }  

  getKNRQuotePolicyList(payload:KnrPolicySearchRequest) : Observable<KnrPolicySearchResponse>
  {    
      let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;
      const url = `${baseURL}search`;   
      return this.postv1<KnrPolicySearchResponse>(url, { body: payload },knrServiceApiKey).pipe(
        map(data => this.mapToQuotePolicyList(data,payload)) ,
        catchError(this.handleError)     
      );
  } 
  private mapToQuotePolicyList(data:any,payload:KnrPolicySearchRequest) : KnrPolicySearchResponse {
    if (!data) return;
    let policyGridRows: KnrPolicySearchResult[] = [];
    let knrDashboardGrid =  new KnrPolicySearchResponse();
    for (let index = 0; index < data.searchDetails.length; index++) {     
          const element = data.searchDetails[index];      
          let row = new KnrPolicySearchResult();  
          row.QuoteId = element.quoteId;    
          row.QuoteNumber = element.quoteNumber;
          row.PolicyNumber = element.policyNumber;
          row.InsuredName = element.insuredName;
          row.Underwriter = element.underwriter;
          row.Broker = element.brokerName;
          row.Status = element.status;
          row.AS400QuoteNumber = element.aS400QuoteNumber;
          row.PolicyType = element.policyType;
          row.CarrierName = element.carrierName;
          row.NewRenewal = element.newRenewal;
          if(element.creationDate){
          row.CreationDate  = this.dateService.toShortDate(
                  this.dateService.moment(element.creationDate.toString())                  
                );  
              }        
      if (payload.insuredName !== "" || payload.quoteNumber !== "" || payload.quoteNumber !== "")
          row.isSearched = true;
      else
          row.isSearched = false;
          policyGridRows.push(row);
       }
    knrDashboardGrid.policySearchResults = policyGridRows; 
    return knrDashboardGrid;
  } 
  getEndorsementsVariablesDetails(quoteId: string): Observable<endorsementsVariablesDetails>{  
     let baseURL = this.knrServiceBaseUrl;   
     let knrServiceApiKey = this.knrServiceAPIKey;
     const headerDict = {
      'Content-Type': 'application/json',
      'x-api-key': knrServiceApiKey
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };         
     const url = `${baseURL}endorsementinfo/${quoteId}`;
    return this.http.get<endorsementsVariablesDetails>(url,requestOptions).pipe(
            map(data => this.mapToEndorsementsVarDetail(data)),
            catchError(this.handleError)
          );
  }
  private mapToEndorsementsVarDetail(data:any) : endorsementsVariablesDetails {
    if (!data) return;    
    let {
      quoteId,   
      endorsements   
    } = data;
    let entitiyQuote: endorsementsVariablesDetails = {
        quoteId,   
        endorsements       
    };    
    return entitiyQuote;
  }
  getQuoteDetails(quoteId: string,useCache:boolean): Observable<quoteDetail>{
    if( useCache && (this.quoteDetailCache &&
      this.quoteDetailCache.rating.modifiedBasePremium)      
      ){
        return of(this.quoteDetailCache);
      }
     let baseURL = this.knrServiceBaseUrl;   
     let knrServiceApiKey = this.knrServiceAPIKey;
     const headerDict = {
      'Content-Type': 'application/json',
      'x-api-key': knrServiceApiKey,
      'Authorization': 'Bearer ' + this.token.accessToken.accessToken
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };         
     const url = `${baseURL}quote/${quoteId}`;
    return this.http.get<QuoteResponseData>(url,requestOptions).pipe(
            map(data => this.mapToQuoteDetail(data)),
            catchError(this.handleError)
          );
  }
  private mapToQuoteDetail(data:any) : quoteDetail {
    if (!data) return;    
    let {
      quoteId,   
      quoteNumber,   
      productType,   
      insured,   
      underwritingInformation,          
      rating, 
      quoteInfo,
      wwExposure      
    } = data.quoteDetails;
    let entitiyQuote: quoteDetail = {
        quoteId,   
        quoteNumber,   
        productType,   
        insured,   
        underwritingInformation,            
        rating, 
        quoteInfo,
        wwExposure        
    };
    this.quoteDetailCache = entitiyQuote;
    return entitiyQuote;
  }
  replaceCurrencySign(value:any) : any{
    return value.replace(
      /[,$,R$,kr,€,$,₹,¥,₩,R,£,zł,Rs]/g,
      ''
    );
   }
  updateQuote(payload:UpdateQuoteRequest) : Observable<quoteDetail>
  {    
      let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;      
      const url = `${baseURL}generatequote`;   
      return this.postv1<UpdateQuoteRequest>(url, { body: payload },knrServiceApiKey).pipe(
        map(data => this.mapToUpdateQuoteResponse(data)) ,
        catchError(this.handleError)     
      );
  }
  mapToUpdateQuoteResponse(data:any): quoteDetail{
    let quoteResponse = new quoteDetail();
    if(!data) return null;
    quoteResponse.quoteId = data.quoteId;
    quoteResponse.quoteNumber = data.quoteNumber;
    return quoteResponse;
  }
  calculateRating(payload: RatingRequest) :  Observable<RatingResponse>
  {
    let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;      
      const url = `${baseURL}price`;   
      return this.postv1<RatingRequest>(url, { body: payload },knrServiceApiKey).pipe(
        map(data => this.mapToRatingResponse(data)) ,
        catchError(this.handleError)     
      );
  }
  mapToRatingResponse(data: any): RatingResponse{   
    let ratingResponse = new RatingResponse();   
    ratingResponse.LimitPremiums = [];
    if (data.errors !== null) {
      return data;
    }    
    ratingResponse.QuoteId = data.quoteId;
    ratingResponse.QuoteNumber = data.quoteNumber;    
    let wwexposure = new WWExposure();    
    data.limitPremiums.forEach(d => { 
      let finalPremium = new FinalPremiums();
      let premiums = new Premiums();
      let limitPremiums = new LimitPremiums();
      limitPremiums.LimitOfInsurance = d.limitOfInsurance;
      finalPremium.OneYearPremium = d.finalPremiums.OneYearPremium;
      finalPremium.TwoYearPremium = d.finalPremiums.TwoYearPremium;
      finalPremium.ThreeYearPremium = d.finalPremiums.ThreeYearPremium;
      finalPremium.ThreeYearInsPremium = d.finalPremiums.ThreeYearInsPremium;
      limitPremiums.FinalPremiums = finalPremium;
      premiums.Base = d.premiums.Base;
      premiums.MedEvac = d.premiums.MedEvac;
      premiums.ModBase = d.premiums.ModBase;
      premiums.ModLimit = d.premiums.ModLimit;
      premiums.WPV = d.premiums.WPV;
      limitPremiums.Premiums = premiums;
      ratingResponse.LimitPremiums.push(limitPremiums);
    });    
    wwexposure.TotalExposurePoints = data.wwExposure.TotalExposurePoints;
    ratingResponse.WWExposure = wwexposure;
    return ratingResponse;
  }
  getAccountSetupData(){
    if( this.accountSetupCachedData &&
        this.accountSetupCachedData.Carriers.length    
      ){
        return of(this.accountSetupCachedData);
     }
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}data/account`;
   return this.http.get<AccountSetupResponse>(url,requestOptions).pipe(
           map(data => this.AccountSetupMapper(data)),
           catchError(this.handleError)
         );
  } 
  getSubjectivityConfigData() {
    if( this.subjectivitiesDataResponseCache &&
      this.subjectivitiesDataResponseCache.subjectivities.length      
    ){
      return of(this.subjectivitiesDataResponseCache);
   }
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}data/subjectivities`;
   return this.http.get<SubjectivitiesDataResponse>(url,requestOptions).pipe(
           map(data => this.SubjectivitiesSetupMapper(data)),
           catchError(this.handleError)
         );
  }
  getQuoteInfoCoveragesData(){ 
    if( this.quoteInfoCoveragesCacheData &&
        this.quoteInfoCoveragesCacheData.TermLengths.length      
      ){
        return of(this.quoteInfoCoveragesCacheData);
     }
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}data/quoteinfo`;
   return this.http.get<QuoteInfoCoveragesResponse>(url,requestOptions).pipe(
           map(data => this.QuoteInfoCoveragesMapper(data)),
           catchError(this.handleError)
         );
  }
  private QuoteInfoCoveragesMapper(data: any): QuoteInfoCoveragesResponse {    
    let datad = data.data;
    let objdata = new QuoteInfoCoveragesResponse(
                  datad.termLengths,
                  datad.limitsOfLiabilityForInsuranceLosses,
                  datad.additionalCoveredEventExpenses); 
    this.quoteInfoCoveragesCacheData = objdata;
    return objdata;
  }
mapToAccountSetupData(data:any) : AccountSetupResponse {    
    let datad = data.data;
    return new AccountSetupResponse(datad.policyTypes,datad.countries,
                                    datad.statesOrProvinces,
                                    datad.underwriters, datad.assistantUnderwriters,
                                    datad.carriers, datad.currencies);
  } 
  clearAccountSetupData(){
    this.accountSetupCachedData = null;
  }
  private AccountSetupMapper(data: any): AccountSetupResponse {
    let datad = data.data;
    let objdata = new AccountSetupResponse(datad.policyTypes,datad.countries,
                                    datad.statesOrProvinces,
                                    datad.underwriters, datad.assistantUnderwriters,
                                    datad.carriers, datad.currencies); 
    this.accountSetupCachedData = objdata;
    return objdata;
  }
  private SubjectivitiesSetupMapper(data: any): SubjectivitiesDataResponse {    
    let datad = data.data;
    let objdata = new SubjectivitiesDataResponse(datad.subjectivities)
    this.subjectivitiesDataResponseCache = objdata;
    return objdata;
  }

  getRatingData(){
    if( this.ratingCachedData &&
        this.ratingCachedData.BasePremium.companyVisibility.length      
      ){
        return of(this.ratingCachedData);
     }
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}data/rating`;
   return this.http.get<RatingDataResponse>(url,requestOptions).pipe(
           map(data => this.RatingMapper(data)),
           catchError(this.handleError)
         );
  }
  private RatingMapper(data: any): RatingDataResponse {
    let datad = data.data;
    let objdata = new RatingDataResponse(datad.basePremium,datad.modifiedBasePremium,datad.limitModification,
      datad.coverageModifiers,datad.riskQualityModifiers,datad.workplaceViolence);
    this.ratingCachedData = objdata;
    return objdata;
  }

  AddQuoteInfoCoverages(payload: QuoteInfoCoveragesRequest): Observable<string> {
    let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;      
      const url = `${baseURL}quoteinfo`;   
      return this.postv1<QuoteInfoCoveragesRequest>(url, { body: payload },knrServiceApiKey).pipe(
        map(data => data.QuoteID) ,
        catchError(this.handleError)     
      );
  }
  CreateRenewalInfo(payload: RenewalInfoRequest): Observable<string> {
    let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;      
      const url = `${baseURL}renewalinfo`;   
      return this.postv1<RenewalInfoRequest>(url, { body: payload },knrServiceApiKey).pipe(
        map(data => data.QuoteID) ,
        catchError(this.handleError)     
      );
  }
  getSubjectivity(quoteId:any)  : Observable<KnRSubjectivityGrid>
  {   
      let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;
      const headerDict = {
      'Content-Type': 'application/json',
      'x-api-key': knrServiceApiKey,
      'Authorization': 'Bearer ' + this.token.accessToken.accessToken
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };         
      const url = `${baseURL}subjectivities/${quoteId}`;
    return this.http.get<KnRSubjectivityGrid>(url,requestOptions).pipe(
            map(data => this.mapToQuoteGridRow(data)),
            catchError(this.handleError)
          );
  }
  mapToQuoteGridRow(data: any): KnRSubjectivityGrid {    
    let subjectivityGrid = new KnRSubjectivityGrid();
    if (!data || !data.subjectivities) return;
    if (data.subjectivities) {
      let gridRows: KnRSubjectivityGridRow[] = [];
      for (let index = 0; index < data.subjectivities.length; index++) {
        const element = data.subjectivities[index];

        let row = new KnRSubjectivityGridRow();
        row.description = element.description;
        row.checked = element.isResolved;
        row.policySubjectivityId = element.id;

        gridRows.push(row);
      }
      subjectivityGrid.subjectivityData = gridRows;
    }
    return subjectivityGrid;
  }
  saveSubjectivity(payload:any): Observable<string>  {
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;      
    const url = `${baseURL}subjectivities`;   
    return this.postv1<KnRSaveSubjectiviyRequest>(url, { body: payload },knrServiceApiKey).pipe(
      map(data => this.mapSaveSubjectivity(data)) ,
      catchError(this.handleError)     
    );
  }
  mapSaveSubjectivity(data: any) {   
    return data.quoteId;
  }
  saveCountryDetails(payload:any): Observable<string>  {
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;      
    const url = `${baseURL}countrydetails`;   
    return this.postv1<SaveCountryDetailsRequest>(url, { body: payload },knrServiceApiKey).pipe(
      map(data => this.mapCountryDetails(data)) ,
      catchError(this.handleError)     
    );
  }
  mapCountryDetails(data: any) {   
    return data.quoteId;
  }
  getCountryDetails(quoteId:any)  : Observable<CountryDetailsList>
  {   
      let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;
      const headerDict = {
      'Content-Type': 'application/json',
      'x-api-key': knrServiceApiKey,
      'Authorization': 'Bearer ' + this.token.accessToken.accessToken
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };         
      const url = `${baseURL}countrydetails/${quoteId}`;
    return this.http.get<CountryDetailsList>(url,requestOptions).pipe(
            map(data => this.mapToCountryDetailsRow(data)),
            catchError(this.handleError)
          );
  }
  mapToCountryDetailsRow(data: any): CountryDetailsList {    
    let countryDetail = new CountryDetailsList();    
    if (!data || !data.countryDetails) return;
    if (data.countryDetails) {
      let countryRows: CountryDetailsRow[] = [];
      for (let index = 0; index < data.countryDetails.length; index++) {        
        const element = data.countryDetails[index];
        let row = new CountryDetailsRow();
        row.CountryCode = element.countryCode;
        row.CountryName = element.countryName;
        row.ExPats = element.exPats;
        row.TravelOnly = element.travelOnly;
        row.NumberExPats = element.numberExPats;
        row.LocalNats = element.localNats;
        row.NumberLocalNats = element.numberLocalNats;
        countryRows.push(row);
      }
      countryDetail.countryDetailsData = countryRows;
    }
    return countryDetail;
  }
  getEndorsementsConfigData() {
    if( this.endorsementsDataResponseCache &&
      this.endorsementsDataResponseCache.endorsements.length      
    ){
      return of(this.endorsementsDataResponseCache);
   }
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}data/endorsements`;
   return this.http.get<EndorsementsDataResponse>(url,requestOptions).pipe(
           map(data => this.EndorsementsSetupMapper(data)),
           catchError(this.handleError)
         );
  }
  private EndorsementsSetupMapper(data: any): EndorsementsDataResponse {       
    let datad = data.data;
    let objdata = new EndorsementsDataResponse(datad.endorsements)
    this.endorsementsDataResponseCache = objdata;
    return objdata;
  }
  saveEndorsements(payload:any): Observable<string>  {
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;      
    const url = `${baseURL}endorsements`;   
    return this.postv1<KnRSaveEndorsementsRequest>(url, { body: payload },knrServiceApiKey).pipe(
      map(data => this.mapSavedEndorsements(data)) ,
      catchError(this.handleError)     
    );
  }
  mapSavedEndorsements(data: any) {   
    return data.quoteId;
  }
  saveEndorsementsVariables(payload:any): Observable<string>  {
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;      
    const url = `${baseURL}endorsementinfo`;   
    return this.postv1<EndorsementsVariablesRequest>(url, { body: payload },knrServiceApiKey).pipe(
      map(data => this.mapSavedEndorsementsVariables(data)) ,
      catchError(this.handleError)     
    );
  }
  mapSavedEndorsementsVariables(data: any) {   
    return data.quoteId;
  }
  getEndorsements(quoteId:any)  : Observable<KnREndorsementsGrid>
  {   
      let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;
      const headerDict = {
      'Content-Type': 'application/json',
      'x-api-key': knrServiceApiKey,
      'Authorization': 'Bearer ' + this.token.accessToken.accessToken
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };         
      const url = `${baseURL}endorsements/${quoteId}`;
    return this.http.get<KnREndorsementsGrid>(url,requestOptions).pipe(
            map(data => this.mapToEndorsementsGridRow(data)),
            catchError(this.handleError)
          );
  }
  mapToEndorsementsGridRow(data: any): KnREndorsementsGrid {    
    let endorsementsGrid = new KnREndorsementsGrid();    
    if (!data || !data.endorsements) return;
    if (data.endorsements) {
      let gridRows: KnREndorsementsGridRow[] = [];
      for (let index = 0; index < data.endorsements.length; index++) {
        const element = data.endorsements[index];
        let row = new KnREndorsementsGridRow();
        row.description = element.endorsementName;        
        row.policyEndorsementsId = element.id;
        gridRows.push(row);
      }
      endorsementsGrid.endorsementsData = gridRows;
    }
    return endorsementsGrid;
  }
  getEndorsementsVariableData(){ 
      if( this.endorsementsVariableDataResponseCache &&
          this.endorsementsVariableDataResponseCache.lossOfEarnings.perInsuredEvent.length      
        ){
          return of(this.endorsementsVariableDataResponseCache);
      }
      let baseURL = this.knrServiceBaseUrl;   
      let knrServiceApiKey = this.knrServiceAPIKey;
      const headerDict = {
      'Content-Type': 'application/json',
      'x-api-key': knrServiceApiKey,
      'Authorization': 'Bearer ' + this.token.accessToken.accessToken
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };         
      const url = `${baseURL}data/endorsementinfo`;
    return this.http.get<EndorsementsVarDataResponse>(url,requestOptions).pipe(
            map(data => this.EndorsementsVariableMapper(data)),
            catchError(this.handleError)
          );
  }
  private EndorsementsVariableMapper(data: any): EndorsementsVarDataResponse {    
    let datad = data.data;
    let objdata = new EndorsementsVarDataResponse(
                datad.lossOfEarnings,
                datad.exPatSecurityEvac,
                datad.travelSecurityEvac,
                datad.enhancedExPatSecurityEvac,
                datad.enhancedTravelSecurityEvac,
                datad.childAbduction,
                datad.enhancedChildAbduction,
                datad.workplaceViolence,
                datad.valueOfProducts
             ); 
    this.endorsementsVariableDataResponseCache = objdata;
    return objdata;
  }
  getRenewalInfoData(){   
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}data/renewalinfo`;
   return this.http.get<RenewalInfoDataResponse>(url,requestOptions).pipe(
           map(data => this.RenewalInfoDataMapper(data)),
           catchError(this.handleError)
         );
  }
  private RenewalInfoDataMapper(data: any): RenewalInfoDataResponse {    
    let datad = data.data;   
    let objdata = new RenewalInfoDataResponse(datad.termDetails,datad.coverageDetails,datad.lossOfEarnings,
      datad.exPatSecurityEvac, datad.travelSecurityEvac, datad.enhancedExPatSecurityEvac,datad.enhancedTravelSecurityEvac,
      datad.childAbduction, datad.enhancedChildAbduction,datad.workplaceViolence,datad.valueOfProducts);    
    return objdata;
  } 
  getRenewalInfo(quoteId: string): Observable<RenewalInfoResponse>{  
    let baseURL = this.knrServiceBaseUrl;   
    let knrServiceApiKey = this.knrServiceAPIKey;
    const headerDict = {
     'Content-Type': 'application/json',
     'x-api-key': knrServiceApiKey,
     'Authorization': 'Bearer ' + this.token.accessToken.accessToken
   }
   const requestOptions = {                                                                                                                                                                                 
     headers: new HttpHeaders(headerDict), 
   };         
    const url = `${baseURL}renewalinfo/${quoteId}`;
   return this.http.get<RenewalInfoResponse>(url,requestOptions).pipe(
           map(data => this.RenewalInfoMapper(data)),
           catchError(this.handleError)
         );
 }
 private RenewalInfoMapper(data:any) : RenewalInfoResponse {  
   let objdata = new RenewalInfoResponse(data.quoteId,
     data.termDetails,
     data.coverageDetails,
     data.medEvac,
     data.lossOfEarnings,
     data.exPatSecurityEvac,
     data.travelSecurityEvac,
     data.enhancedExPatSecurityEvac,
     data.enhancedTravelSecurityEvac,
     data.childAbduction,
     data.enhancedChildAbduction,
     data.amendedAssetThreshold,
     data.valueOfProducts,
     data.workplaceViolence);
   return objdata;
 }
}
